import { Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AngularFireStorage } from '@angular/fire/storage';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { concat, empty, Subscription } from "rxjs";
import { AuthService } from 'src/app/shared/services/auth.service';
import { DialogService } from 'src/app/shared/services/dialog.service';


interface empresaCliente {
  id: string,
  nombre: string,
  resumen: string,
  descripcion: string,
  sitioWeb: string,
  enlaceLinkedin: string,
  foto: string,
  cantCursos: number,
  cantUsuarios: number,
  cantCupos: number,
  creador: string,
  fechaCreacion: Date,
  ultimaEdicion: Date,
  ultimoEditor: string,
  publicado: string,
}

export interface curso{
  publicado: boolean;
  titulo: string;
  id: string;
}

@Component({
  selector: 'dashboard-admin-empresa',
  templateUrl: './dashboard-admin-empresa.component.html',
  styleUrls: ['./dashboard-admin-empresa.component.css']
})
export class DashboardAdminEmpresaComponent implements OnInit {

  id = this.route.snapshot.paramMap.get('id');
  loaded: number = 0;
  // infomacion del adminstrador:
  usuario: any;
  userToken: string;
  subscripcionUsuario: Subscription
  subscripcionToken: Subscription
  agregarUsuario: number = 0;
  usuariosEmpresa: any[] = [];
  listaCursos: curso[];
  cursoId: string[];
  inscribirUsuarios: any[] = [];

  empresa: empresaCliente = {
    id: '',
    nombre: '',
    resumen: '',
    descripcion: '',
    sitioWeb: '',
    enlaceLinkedin: '',
    foto: '',
    cantCursos: 0,
    cantUsuarios: 0,
    cantCupos: 0,
    creador: '',
    fechaCreacion: new Date,
    ultimaEdicion: new Date,
    ultimoEditor: '',
    publicado: '',
  }

  constructor(
    public dialog: MatDialog,
    private shared: RoutingVariablesService,
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    private storage: AngularFireStorage,
    private _snackBar: MatSnackBar,
    public authService: AuthService,
    public dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.subscripcionUsuario = this.shared.getUsuario().subscribe(usuario => {
      this.usuario = usuario.usuario;
    })
    this.subscripcionToken = this.shared.getToken().subscribe(token => {
      this.userToken = token.token;
    })
    this.cargarEmpresa()
    this.cargarCursos()
  }

  cargarEmpresa() {
    this.afs.collection('empresasCliente').doc(this.id).ref.get().then(doc => {
      const empresa = doc.data();
      this.empresa = {
        id: this.id,
        nombre: empresa['nombre'],
        resumen: empresa['resumen'],
        descripcion: empresa['descripcion'],
        sitioWeb: empresa['sitioWeb'],
        enlaceLinkedin: empresa['enlaceLinkedin'],
        foto: empresa['foto'],
        cantCursos: empresa['cantCursos'],
        cantUsuarios: empresa['cantUsuarios'],
        cantCupos: empresa['cantCupos'],
        creador: empresa['creador'],
        fechaCreacion: empresa['fechaCreacion'],
        ultimaEdicion: empresa['ultimaEdicion'],
        ultimoEditor: empresa['ultimoEditor'],
        publicado: empresa['publicado']
      }
      this.loaded = 1;
      this.cargarUsuariosEmpresa();
    }).catch(error => {
      console.log(error)
      alert('No se ha podido guardar la empresa')
    });
  }

  async cargarUsuariosEmpresa() {
    this.afs.collection('usuariosEmpresa').ref.where('empresaId', "==", this.empresa.id).get().then(response => {
      console.log(this.empresa.id)
      response.docs.forEach(doc => {
        const usuarioEmpresa = {
          id: doc.id,
          ...doc.data() as {}
        }
        this.usuariosEmpresa = this.usuariosEmpresa.concat(usuarioEmpresa);
      })
    })
  }

  cargarCursos(){
    this.afs.doc("global/indiceCursos").get().subscribe(snap => {
      const cursos = snap.data();
      let arr = []
      Object.keys(cursos).map(function(key) {
        arr.push(cursos[key])
        return arr;
      }); 
      const length = arr.length
      let arreglo = []   
      for (let index = 0; index < length; index++) {
        const curso: curso = {
          titulo: arr[index][0].titulo,
          publicado: arr[index][0].publicado,
          id: arr[index][0].id,
        }
        arreglo.push(curso)               
      }
      this.listaCursos = arreglo
      console.log(this.listaCursos)
    })
  }

  asignarCursoUsuarios(email){
    let existe: number = 0;



    if (this.inscribirUsuarios.length == 0){
      this.inscribirUsuarios = this.inscribirUsuarios.concat(email) 
      console.log('agregue elprimer elemento')
    } else {
      for (var i = 0; i < this.inscribirUsuarios.length; i++) {
        // console.log(i + " " + email + " == " + this.inscribirUsuarios[i])
        if  (this.inscribirUsuarios[i] == email){
          // delete this.inscribirUsuarios[i]

          this.inscribirUsuarios.filter(arr => arr == email)
          console.log('elimine el elemento porque ya existia')
        }
      }
    }


    console.log(this.inscribirUsuarios)

    }

    onDelete(){
      this.dialogService.dialogConfirmar().afterClosed().subscribe(res => {
        console.log('respuesta')
        console.log(res);
      });
    }


}
